import React from "react";
import DOMPurify from "dompurify";

// Convert @[name] mentions to a styled span, then sanitize and render HTML.
export const renderRichText = (note: string) => {
  if (!note) return null;

  const withMentions = note.replace(/\@\[(.*?)\]/g, (_match, p1) => {
    const safeName = DOMPurify.sanitize(p1 || "");
    return `<span class=\"font-semibold\">@${safeName}</span>`;
  });

  const safeHtml = DOMPurify.sanitize(withMentions, { ALLOWED_ATTR: ["class"] });

  return (
    <div
      className={"rich-text-content"}
      dangerouslySetInnerHTML={{
        __html: safeHtml,
      }}
    />
  );
};

// preserve original name for backward compatibility
export const parseNote = renderRichText;
